var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:[_vm.iconStateClass, _vm.iconVariantClass],attrs:{"aria-label":_vm.ariaLabel,"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }